import React from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';
import cn from 'classnames';

import styles from './ScrollNav.module.postcss';

function ScrollNav({ links, offset, isLocation = false }) {

  const linkList = links.map((link) => {
    return (
      <Scroll.Link
        key={link.to}
        offset={offset}
        smooth
        to={link.to}
        activeClass="active"
      >
        {link.title}
      </Scroll.Link>
    );
  });

  return (
    <nav aria-label='Page sections' className={cn(styles.ScrollNav, 'Section u-pt0 u-pb0', {
        [styles.ScrollNav__location]: isLocation
    })} >
      {linkList}
    </nav>
  );
}

ScrollNav.propTypes = {
  offset: PropTypes.number.isRequired,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ScrollNav;
